export default function() {
  const widgetName = 'cardsWidgetSection';
  const widgetOpts = cardsWidgetSectionOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      function modifyCardWidgets() {
        const cardsWidgetSection = document.querySelector('#cardsWidgetSection');
        const cardItems = cardsWidgetSection.querySelectorAll('.card-widget-item');

        cardItems.forEach(cardItem => {
          const imageContainer = cardItem.querySelector('.image-container');
          const cardTitle = cardItem.querySelector('.card-widget-title');

          imageContainer.parentNode.insertBefore(cardTitle, imageContainer.nextSibling);
      });
    }
    modifyCardWidgets();
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 9,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true
  });

}